<template>
  <div class="mainContainer">  
    <div class="fixedHeroVideo">
        <home-hero :sectionDataIndex="0"></home-hero>
    </div>

    <main v-if="siteReady" id="mainScroller" class="mainContent">

<!--       <div class="stickWrap"><div class="stickInner">Test<br/>Test<br/>Test<br/>Test<br/>Test<br/></div></div>
      <div>after stick<br/>after stick<br/>after stick<br/>after stick<br/>after stick<br/>after stick<br/>after stick<br/>after stick<br/>after stick<br/>after stick<br/></div>
 -->

      <section class="siteSection transparentSection">
        &nbsp; <!--empty transparent section for the video bg-->
      </section>
      <section class="siteSection heroText">
        <home-hero-text :sectionDataIndex="0"></home-hero-text>
      </section>
      <section class="siteSection secBgGray1 sequence desktop-only-sequence">
        <!-- <home-benefits :sectionDataIndex="1"></home-benefits> -->
         <!-- <circular :sectionDataIndex="1" :sectionScrollProg="sectionScrollProg"></circular> -->
        <panels :sectionDataIndex="1" :sectionScrollProg="sectionScrollProg"></panels>
      </section>
      <section class="siteSection">
        <testimonials :sectionDataIndex="2" :sectionScrollProg="sectionScrollProg"></testimonials>
      </section>

      <!-- test sticky section animation 
      <section class="siteSection sequence">
          <div class="motionSection">
              <div class="stickySec">
                <div :style="'--prog:'+sectionScrollProg.prog" class="progtest"></div>
                 {{sectionScrollProg.index}}
                {{sectionScrollProg.prog}}
              </div>
          </div>
      </section>
      -->
      <!-- test sticky section animation -->
      
      <!-- <section class="siteSection wfBg sequence"> -->
      <section class="siteSection secBgGray1 sequence">
        <!-- <workflow :sectionDataIndex="2"></workflow> -->
        <!-- <circular :sectionDataIndex="3" :sectionScrollProg="sectionScrollProg"></circular> -->
        <!-- <div class="wfBgInner"> -->
          <timeline :sectionDataIndex="3" :sectionScrollProg="sectionScrollProg"></timeline>
        <!-- </div> -->
      </section>

      <section class="siteSection minimized secBgGray1">
        <clinical-cases :sectionDataIndex="4"></clinical-cases>
      </section>

      <section class="siteSection secBgGray2 minimized">
         <videos :sectionDataIndex="5"></videos>
      </section>

      <section class="siteSection secBgGray1">
        <surgicalkits :sectionDataIndex="6"></surgicalkits>
      </section>

      <section class="siteSection sequence secBgGray1">
        <msoft :sectionDataIndex="7" :sectionScrollProg="sectionScrollProg"></msoft>
      </section>

      <section class="siteSection secBgGray1 minimized">
        <mcenters :sectionDataIndex="8"></mcenters>
      </section>


      <section class="siteSection footer">
        <app-footer></app-footer>
      </section>
    </main>
  </div>
</template>

<style>
.wfBg
{
      background-attachment: fixed;
      background-image: url('test.png');
      background-position: center center;
      background-size: cover;
      background-blend-mode: lighten;
}
.wfBgInner
{
  background-color: rgba(255, 255, 255, 0.9);
}
  .siteSection.sequence
  {
    height: 300vh;
    background-color: black;
  }

  
  .motionSection
  {    
    height: 300vh;
    color: #fff;
  }
  .stickySec
  {
    position: sticky;
    top: 0px;
    display: flex;
    overflow: visible;
    height: 100vh;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
  .stickySec > div{
    clear: both;
    display: block;
  }
  .progtest
  {
    clear: both;
    height: 3px;
    display: block;
    background-color: red;
    width: calc(100% * var(--prog));
    transition: all ease 0.3s;
  }

  @media (max-width: 850px) 
  {
    .siteSection.desktop-only-sequence
    {
      height: auto !important;
    }
  }


</style>

<script>
  import HomeHero             from "@/views/lance/LanceHero.vue";
  import HomeHeroText         from "@/views/lance/LanceHeroText.vue";
  import HomeBenefits         from "@/views/lance/Benefits.vue";
  import Circular             from "@/views/lance/Circular.vue";
  import ClinicalCases        from "@/views/lance/ClinicalCases.vue";
  import Timeline             from "@/views/lance/Timeline.vue";
  import Panels               from "@/views/lance/Panels.vue";
  import Photos               from "@/views/lance/Photos.vue";
  import Videos               from "@/views/lance/Vimeos.vue"; //<Vimeo version
  import Workflow             from "@/views/lance/Workflow.vue";  
  import surgicalkits         from "@/views/lance/SurgicalKits.vue";  
  import DigitalRestoration   from "@/views/lance/DigitalRestoration.vue";  
  import DigitalItems         from "@/views/lance/DigitalItems.vue";  
  import TutorialVideos       from "@/views/lance/TutorialVideos.vue";    
  import Mcenters             from "@/views/lance/Mcenters.vue";    
  import Msoft                from "@/views/lance/Msoft.vue";    
  import Testimonials                from "@/views/lance/Testimonials.vue";      
  import AppFooter            from "@/views/lance/AppFooter.vue";

  import { mapActions, mapState } from "vuex";
  
  export default 
  {
    data(){
      return{
        animTest:'',
        site_data:null,
        isMenuOpen:false,
        isLangOpen:false
      }
    },
    components:
    {
      HomeHero,
      HomeHeroText,
      surgicalkits,
      HomeBenefits,
      Circular,Panels,Timeline,ClinicalCases,
      DigitalRestoration,
      DigitalItems,      
      Workflow,
      TutorialVideos,
      Mcenters,Msoft,
      AppFooter,
      Photos,
      Videos,
      Testimonials
    }, 
    computed: {
      ...mapState(["sectionScrollProg","siteData","siteDataReady","siteReady","siteVisibleSection"]),
  },
  mounted()
  {
    this.loadMapData(); //*** specific for mguide mcenters map data
    this.loadCasesData();
  },
  created: function () {      
      //var vm = this;      
  },
  watch:
  {
    '$store.state.siteVisibleSection': function(){
      var vm = this;
      let _siteVisibleSection = this.$store.state.siteVisibleSection;
      vm.onSectionVisible(_siteVisibleSection);
    }
  },
  methods: {
    ...mapActions(["loadSiteData","loadMapData","loadCasesData","setVisibleSection"]),  
    onSectionVisible(domSectionIndex)
    {
        //////////////// SPECIFIC SITE CODE START ////////////////////
        let sectionIndex = domSectionIndex;
        let sectionDataIndex = sectionIndex;
        if(sectionIndex>0){
          sectionDataIndex--;//!important because the dom 1st section is empty section
        }
        var secData =  this.siteData.SECTIONS[sectionDataIndex];
        
        
        //PLAY/PAUSE VIDEO ACCORDING TO THE SCROLL POSITION
        var vid = document.getElementById("videoBgHero");
        //vid.pause();
        
        if(domSectionIndex>1){          
          vid.pause();
        }else{
          vid.play();
        }

        if(secData.section=='benefits')
        {
          //the scroller on benefits is hidden becuase it's stopping the site from scrolling the hero to the benefits
          //when revealing the 'benefits' section set timeout for 1 sec and show the benfits scroller
          //imgBnScroller1 add 'show' class after 1 sec          
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("show");//(display block)
          }, 1100);
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("showOpaq"); //remove opacity            
          }, 1300);
        }
       //////////////// SPECIFIC SITE CODE END ////////////////////
      }
    }
  }
</script>
